import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      request_error: '',
      visits: [],
      current_visit_id: 0,
      current_person: {
        flvisp_id: 0,
        flvisp_first_name: '',
        flvisp_last_name: '',
        flvisp_company: '',
        flvisp_email: '',
        flvisp_phone: '',
        flvisp_website: '',
        flvisp_images:'',
      },
      items_of_search: [],
      item_of_scan: {},
      selected_items: [],
      inserted_item_id: 0,
      edit_visit_flag: 0
    };
  },
  mutations,
  actions,
  getters
};